import {getRandomAlphanumericString} from "@/shared/helpers/strings";
import API from "@/shared/helpers/API";
import {useUserStore} from "@/console-new/stores";
import {useNotificationStore} from "@/shared/stores";

const bucketName = "qromomilan";
const bucketRegion = "eu-south-1";
const IdentityPoolId = "eu-south-1:af70d0a7-d4d8-49a6-8799-677c025ccbf8";


export function uploadImageFile(file, maxWidth, maxHeight, maxSize, createThumbnail, callback, callbackError) {
	if (!file) {
		return;
	}
	let fileExtension = file.name.split('.').pop();
	let fileRandKey = getRandomAlphanumericString(15);
	let fileName = fileRandKey + "." + fileExtension;
	let fileNameFull = fileRandKey+"-full."+fileExtension;
	let albumPhotosKey = "businesses/";
	let photoKey = albumPhotosKey + fileName;
	let photoKeyFull = albumPhotosKey + fileNameFull;

	// Skip compression for PDF files
	if (file.type === 'application/pdf') {
		const userStore = useUserStore();
		API.init().getPreSignedUrl(userStore.currBusinessId, photoKeyFull, file.size, (r) => {
			if(r && r.url) {
				fetch(r.url, {
					method: "PUT",
					headers: {
						"Content-Type": file.type,
					},
					body: file
				})
				.then(() => {
					callback(fileNameFull);
				})
				.catch(err => {
					console.warn('ERROR uploading PDF: ', err);
					if (callbackError) callbackError();
				});
			} else {
				console.log("Error");
				// Check if the error is file_too_big
				if (r && r.result === "KO" && r.details === "file_too_big") {
					const notificationStore = useNotificationStore();
					notificationStore.showNotification('upload-file-too-big');
				}
				callbackError && callbackError();
			}
		});
	} else {
		reduceFileSize(file, maxWidth, maxHeight, maxSize, 0.7, blob => {
			const userStore = useUserStore();
			API.init().getPreSignedUrl(userStore.currBusinessId, photoKeyFull, file.size, (r) => {
				if(r && r.url) {
					fetch(r.url, {
						method: "PUT",
						headers: {
							"Content-Type": blob.type,
						},
						body: blob
					})
					.then(() => {
						if(createThumbnail) {
							reduceFileSize(file, 200, 200, 35 * 1024, 0.7, blob2 => {
								API.init().getPreSignedUrl(userStore.currBusinessId, photoKey, file.size, (r) => {
									if (r && r.url) {
										fetch(r.url, {
											method: "PUT",
											headers: {
												"Content-Type": blob2.type,
											},
											body: blob2
										})
										.then(() => {
											console.log("Thumbnail uploaded");
											callback(fileName);
										})
										.catch(err => {
											console.warn('ERROR uploading image: ', err);
											if (callbackError) callbackError();
										});
									} else {
										console.log("Error");
										// Check if the error is file_too_big
										if (r && r.result === "KO" && r.details === "file_too_big") {
											const notificationStore = useNotificationStore();
											notificationStore.showNotification('upload-file-too-big');
										}
										callbackError && callbackError();
									}
								});
							});
						} else {
							callback(fileNameFull);
						}
					})
					.catch(err => {
						console.warn('ERROR uploading image: ', err);
						if (callbackError) callbackError();
					});
				} else {
					console.log("Error");
					// Check if the error is file_too_big
					if (r && r.result === "KO" && r.details === "file_too_big") {
						const notificationStore = useNotificationStore();
						notificationStore.showNotification('upload-file-too-big');
					}
					callbackError && callbackError();
				}
			});
		});
	}
}

export function reduceFileSize(file, maxWidth, maxHeight, maxSize, quality, callback, lastCompressedSize = null, iterationCount = 1) {

	new Compressor(file, {
		quality: quality,
		maxWidth: maxWidth,
		maxHeight: maxHeight,
		convertTypes: ['image/png'],
		convertSize: maxSize,
		success(newFile) {
			if (newFile.size <= maxSize || lastCompressedSize === newFile.size || iterationCount > 5 || maxWidth < 10 || maxHeight < 10) {
				callback(newFile);
			} else {
				reduceFileSize(newFile, maxWidth * 0.93, maxHeight * 0.93, maxSize, quality, callback, newFile.size, iterationCount + 1);
			}
		},
		error(err) {
			console.error(err.message);
			callback(file);
		},
	});

}
